
import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const WalkAndTalkSection: React.FC = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in order-2 lg:order-1">
            <h2 className="leading-tight">Walk & Talk: Coaching in Bewegung</h2>
            <div className="w-20 h-1 bg-primary my-6"></div>
            <p className="text-joerg-600 mb-6">
              Beim Walk & Talk Coaching bewegen wir uns gemeinsam in der Natur, während wir an deinen Themen arbeiten – ob Führungsentscheidungen, berufliche Weichenstellungen oder persönliche Klarheit. Diese besondere Form des Coachings hat viele Vorteile:
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0" />
                <span className="text-joerg-600">
                  <span className="font-medium">Natürlicher Rhythmus:</span> Das Gehen im eigenen Tempo schafft einen natürlichen Gedankenfluss
                </span>
              </div>
              
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0" />
                <span className="text-joerg-600">
                  <span className="font-medium">Körper und Geist:</span> Die körperliche Aktivität unterstützt mentale Prozesse und fördert neue Erkenntnisse
                </span>
              </div>
              
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0" />
                <span className="text-joerg-600">
                  <span className="font-medium">Gleichberechtigte Gesprächsebene:</span> Beim Nebeneinandergehen entsteht eine natürlichere Kommunikationssituation
                </span>
              </div>
              
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0" />
                <span className="text-joerg-600">
                  <span className="font-medium">Frische Luft, frisches Denken:</span> Der Aufenthalt in der Natur regt zu neuen Gedanken und Lösungsansätzen an
                </span>
              </div>
            </div>
            
            <div className="mt-8">
              <Link 
                to="/kontakt" 
                className="btn-primary rounded-full inline-flex items-center"
              >
                Jetzt Termin vereinbaren
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>
          
          <div className="order-1 lg:order-2 animate-scale-in">
            <div className="overflow-hidden rounded-2xl shadow-elevation">
              <img 
                src="/lovable-uploads/6db01e7b-1e60-47aa-997d-7af28a12dad7.png" 
                alt="Walk & Talk Coaching am Rothsee" 
                className="w-full h-auto object-cover aspect-[4/3] hover:scale-105 transition-transform duration-700"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WalkAndTalkSection;
